<template>
    <div v-if="!hideDropdown" class="dropdown dropdown-search" :class="{ 'is-active': open }">
        <a
            class="button"
            :style="{
                color: selectedCountry === null && usePlaceholderStyles ? '#C2C2C2' : '#363636',
            }"
            @click.prevent="!hideDropdown ? (open = !open) : null"
        >
            {{ $filters.limit(itemDisplay(selectedCountry), 40) }}
            <fa-icon v-if="!hideDropdown" icon="caret-down" class="custom-icon" fixed-width />
        </a>
        <div v-if="open" class="dropdown-body">
            <div class="dropdown-content">
                <div v-if="items.length" class="dropdown-search-results">
                    <a
                        v-for="(item, i) in items"
                        :key="item.key"
                        class="dropdown-item dropdown-search-item"
                        :class="{
                            'is-active': counter === i,
                            'no-hover': counter !== i && counter !== -1,
                        }"
                        @click.prevent="select(item)"
                    >
                        <div class="dropdown-search-item-content">
                            <span>{{ $filters.limit(dropdonwItemDisplay(item), 40) }}</span>
                        </div>
                    </a>
                </div>
                <div v-else class="dropdown-search-results no-results">
                    <p>No Results</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    props: {
        selectedOption: { type: [Object, String], required: false },
        countries: { type: Array, required: true },
        placeholder: { type: String, default: 'Select country' },
        usePlaceholderStyles: { type: Boolean, default: false },
    },

    emits: ['selectOption'],

    data: () => ({
        selectedCountry: null,
        open: false,
        focused: false,
        counter: -1,
        hideDropdown: false,
    }),

    computed: {
        items() {
            const items = this.countries;
            return items;
        },

        total() {
            return this.items ? this.items.length : 0;
        },

        ...mapState(stores.User, ['user']),
    },

    watch: {
        open(open) {
            if (open && this.$refs.input) {
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
                document.addEventListener('keydown', this.handleDocumentKeydown);
            } else {
                document.removeEventListener('keydown', this.handleDocumentKeydown);
            }
        },
        selectedOption(value) {
            if (this.selectedOption !== value) {
                this.select(value);
            }
        },
    },
    methods: {
        handleDocumentClick(e) {
            if (!this.$el.contains(e.target)) {
                this.close();
            }
        },
        close() {
            if (!this.open) {
                return;
            }
            if (this.$refs.input) {
                this.$refs.input.blur();
            }
            this.open = false;
            this.focused = false;
            this.counter = -1;
        },
        focus() {
            this.focused = true;
        },
        blur() {
            this.focused = false;
        },
        focusInput() {
            this.counter = -1;
            this.$refs.input.focus();
        },
        arrowDown() {
            this.$refs.input.blur();
            if (this.counter < this.total - 1) {
                ++this.counter;
            }
        },
        arrowUp() {
            if (this.counter === 0) {
                this.$refs.input.focus();
                this.counter = -1;
            } else if (this.counter > 0) {
                this.$refs.input.blur();
                --this.counter;
            }
        },
        mouseOver(i) {
            this.counter = i;
        },
        mouseOut() {
            this.counter = -1;
        },
        enter() {
            if (this.items[this.counter]) {
                this.select(this.items[this.counter]);
            }
        },
        itemDisplay(item) {
            if (typeof item === 'string' && this.countries.length) {
                const country = this.countries.find((country) => country.key === item);

                return country?.label || this.placeholder;
            }

            return item?.label || this.placeholder;
        },
        dropdonwItemDisplay(item) {
            return item?.label || 'Country';
        },
        select(item) {
            this.selectedCountry = item;
            this.$emit('selectOption', item);
            this.close();
        },
    },
    mounted() {
        if (this.selectedOption) {
            this.selectedCountry = this.selectedOption;
        }
        document.addEventListener('click', this.handleDocumentClick);
    },
    destroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    },
};
</script>
<style scoped>
.dropdown-search-item-content .dropdown-search-item-tag {
    padding: 5px 8px;
    margin-left: 10px;
    color: #fff;
    border-radius: 4px;
}
</style>
